import { Table } from '@material-ui/core'
import { Tributacao } from 'models/Viabilidade/Tributacao'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableCellLabel, TableRowCinza, TableCellValor } from '../index.style'
import { parsePorcentagem } from 'helpers/formatador'

const CartaoTributacao: React.FC<{ dados: Tributacao }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableTributacao">
        <TableRowCinza>
          <TableCellLabel>Tributação Casas (%)</TableCellLabel>
          <TableCellValor data-cy="campoTributacaoCasas">
            <NumberFormat
              value={parsePorcentagem(dados.tributacaoCasas as string)}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              suffix="%"
              decimalScale={2}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowCinza>
          <TableCellLabel>Tributação Lotes (%)</TableCellLabel>
          <TableCellValor data-cy="campoTributacaoLotes">
            <NumberFormat
              value={parsePorcentagem(dados.tributacaoLotes as string)}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
              suffix="%"
              decimalScale={2}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoTributacao
